import React, { forwardRef } from 'react';
import cn from 'classnames';
import Title from 'components/UI/Title';
import Tag from 'components/UI/Tag';

import * as styles from './InitialStep.module.scss';

function InitialStep(
  { className, subtitle, sections, active, setActive, triggerValidation, setTriggerValidation },
  ref,
) {
  const handleInputChange = id => () => {
    setActive(id);
  };

  const onAnimationEnd = e => {
    const lastChildIndex = e.target.parentElement.children.length - 1;

    if (e.target === e.target.parentElement.children[lastChildIndex]) {
      setTriggerValidation(false);
    }
  };

  return (
    <div className={className} ref={ref}>
      <Title tag="h4" className={styles.title}>
        {subtitle}
      </Title>
      <div className={styles.inputsWrapper} onAnimationEnd={onAnimationEnd}>
        {sections.map(({ id, button }, i) => (
          <Tag
            key={id}
            className={cn(styles.tag, triggerValidation && styles.validate)}
            type="button"
            active={active === id}
            theme="calculatorTag"
            mods="withoutMT"
            onClick={handleInputChange(id)}
            style={{ '--animationDelay': `${i * 500}ms` }}
          >
            {button}
          </Tag>
        ))}
      </div>
    </div>
  );
}

export default forwardRef(InitialStep);
